import { Card } from "../../../components/card.component";
import { useCallback, useState, useEffect } from "react";
import searchIcon from "../../../assets/img/search-icon.svg";
import { useAppDispatch, useAppSelector } from "../../../core/redux/ReduxStore";
import { ActionsTaskTable } from "../../../core/redux";
import { TaskList } from "../../../features/taskList/taskList.component";
import { ExportButton } from "../../../components/export.component";
import { AppUserRoles } from "../../../config/constants";
import { StorageAuth } from "../../../core/localStorage/StorageAuth";
import { debounce } from "../../../utils";

export const PageTaskListView = () => {
  const dispatch = useAppDispatch();
  const [searchValue, setSearchValue] = useState("");
  const { pageNumber, pageSize, searchKey } = useAppSelector(
    (state) => state.taskTable
  );

  const searchTaskListList = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      setSearchValue(event.target.value);
      debounce(() => {
        dispatch(ActionsTaskTable.goToPage(1));
        dispatch(ActionsTaskTable.setSearchKey(event.target.value));
      });
    },
    [dispatch]
  );

  useEffect(() => {
    return () => {
      dispatch(ActionsTaskTable.resetData());
    };
  }, [dispatch]);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                {StorageAuth.Role?.toLowerCase() ===
                AppUserRoles.SuperAdmin.toLowerCase()
                  ? "Manage Default TaskList"
                  : "Manage TaskList"}
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-md-4 col-12 mt-1">
            <form className="search-component">
              <div className="input-group me-3">
                <span
                  className="input-group-text pe-2"
                  id="search-component-word"
                >
                  <img src={searchIcon} alt="search-icon" />
                </span>
                <input
                  type="text"
                  className="form-control ps-0"
                  placeholder="Search..."
                  aria-label="Search"
                  aria-describedby="search-component-word"
                  onChange={searchTaskListList}
                  value={searchValue}
                  onKeyPress={(ev) => {
                    ev.key === "Enter" && ev.preventDefault();
                  }}
                />
                {searchKey.length > 0 && (
                  <span
                    className="input-group-text text-green-200"
                    id="search-component-word"
                  >
                    <i
                      className="fas fa-times click"
                      onClick={() => {
                        setSearchValue("");
                        dispatch(ActionsTaskTable.setSearchKey(""));
                      }}
                    />
                  </span>
                )}
              </div>
              <ExportButton
                params={{ pageNumber, pageSize, searchKey }}
                component="PatientTask"
              />
            </form>
          </div>
        </div>
      }
    >
      <TaskList />
    </Card>
  );
};
